import { Component, Input } from '@angular/core';

@Component({
    selector: 'fi-document-template-lock-settings',
    templateUrl: './document-template-lock-settings.component.html',
    standalone: false,
})
export class FiDocumentTemplateLockSettingsComponent {
    @Input() item;
}
